/* eslint-disable */
import { LOGOUT } from '../constants/actions'

export const logoutAction = () => ({
  type: LOGOUT,
})
